module.exports = __webpack_public_path__ + "assets/img/sidebar_menu_fold.d71b1b6e.svg";